import '../IncrementalityPlaybook.scss';
import { IncPlaybookSectionBox } from '../IncrementalityPlaybookShared';
import { playbookData, playbookTable } from '../PlaybookTable';

const PAGE_TITLE = 'Multi-Channel';

export const MultiChannel = () => (
  <div className='inc-playbook-page'>
    <IncPlaybookSectionBox
      content={
        <div className='main-table'>
          {playbookTable(playbookData.filter(row => row.Channel[0].value === 'MultiChannel'))}
        </div>
      }
      pageTitle={PAGE_TITLE}
      title='Incrementality Testing Approaches'
    />
  </div>
);
